const isHome = (url: string = window.location.pathname) => url === "/";
const isCatalogue = (url: string = window.location.pathname) =>
  url.startsWith("/catalogue");
const isProduct = (url: string = window.location.pathname) =>
  url.startsWith("/product");
const isStudio = (url: string = window.location.pathname) => url === "/studio";
const isLookbook = (url: string = window.location.pathname) =>
  url === "/lookbook";

const ignoreElementsFromSelector = (
  mainElements: HTMLElement[],
  ignoredElements: HTMLElement[]
) => {
  // iterate over mainElements and remove the elements that are in ignoredElements
  const newElements: HTMLElement[] = [];
  mainElements.forEach((element: HTMLElement) => {
    if (!ignoredElements.includes(element)) {
      newElements.push(element);
    }
  });

  return newElements;
};

export {
  isHome,
  isCatalogue,
  isProduct,
  isStudio,
  isLookbook,
  ignoreElementsFromSelector,
};
